import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import ChipInput from '~/components/ChipInput';
import InputLabelTooltip from '~/components/InputLabelTooltip';
import MultiPicklist from '~/components/MultiPicklist';
import TextField from '~/components/TextField';
import ToastsContainer from '~/containers/Toasts';
import { emailRegex } from '~/lib/email';
import { hasError } from '~/lib/graphql';
import {
  legacySegmentType,
  readableSegmentType,
  readableSingularSegmentType,
} from '~/lib/segments';
import DeliverTestButton from '~/pages/destinations/components/DeliverTestButton';
import SuppressionForm from '~/pages/destinations/components/SuppressionForm';
import TriggerType from '~/pages/destinations/components/TriggerType';
import defaultTriggerTypes from '~/pages/destinations/components/TriggerType/defaultValues';

import sharedStyles from '../styles';
import styles from './styles';

function hourMenuItems() {
  let hourMenuItems = [];
  for (let i = 1; i <= 12; i++) {
    hourMenuItems.push(
      <MenuItem key={i} value={i}>
        {i}
      </MenuItem>,
    );
  }
  return hourMenuItems;
}

const placeholderValue = 'hourly';

class Email extends React.Component {
  state = {
    duplicateSuppressionTimeframe: 0,
    frequency: 'hourly',
    recipients: [],
    subject: null,
    testRecipient: '',
    triggerType: 'segment_enter',
    columns: [],
  };

  UNSAFE_componentWillMount() {
    if (this.props.destination) {
      this.setState({
        ...this.props.destination,
        ...this.props.destination.config,
        testRecipient: this.props.destination.config.recipients[0],
      });
    }
  }

  handleFieldChange = (name, value) => {
    this.setState({ [name]: value }, this.handleInputChange);
  };

  handleInputChange = () => {
    const { onInputChange } = this.props;

    const {
      columns,
      duplicateSuppressionTimeframe,
      frequency,
      scheduleDay,
      scheduleHour,
      scheduleStartOfPeriod,
      recipients,
      subject,
      triggerType,
    } = this.state;

    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    onInputChange({
      config: {
        columns,
        duplicateSuppressionTimeframe,
        frequency,
        scheduleDay: scheduleDay || 0,
        scheduleHour: scheduleHour || 9,
        scheduleStartOfPeriod,
        recipients,
        subject,
        timeZone,
      },
      triggerType,
    });
  };

  handleAmPmChange = (event) => {
    const { value } = event.target;
    const { scheduleHour } = this.state;

    this.handleHourAndAmPmChange(scheduleHour, value);
  };

  handleHourAndAmPmChange = (scheduleHour, amPm) => {
    if (amPm === 'pm' && scheduleHour === 12) {
      // midday
      scheduleHour = 12;
    } else if (amPm === 'am' && scheduleHour === 12) {
      // midnight
      scheduleHour = 0;
    } else if (amPm === 'pm' && scheduleHour < 12) {
      // afternoon
      scheduleHour += 12;
    } else if (amPm === 'am' && scheduleHour > 12) {
      // morning
      scheduleHour -= 12;
    }

    this.setState({ scheduleHour }, this.handleInputChange);
  };

  handleHourChange = (event) => {
    let { value } = event.target;
    const { scheduleHour } = this.state;

    let amPm;
    if (scheduleHour === 0) {
      amPm = 'am';
    } else if (scheduleHour === 12) {
      amPm = 'pm';
    } else if (scheduleHour < 12) {
      amPm = 'am';
    } else if (scheduleHour > 12) {
      amPm = 'pm';
    }

    this.handleHourAndAmPmChange(value, amPm);
  };

  addRecipient = (newRecipient) => {
    if (newRecipient === '') {
      return;
    }

    if (!newRecipient.match(emailRegex)) {
      ToastsContainer.addWarning(
        'That email address is not valid. Please try again.',
      );
      return;
    }

    if (newRecipient)
      this.setState(
        ({ recipients }) => ({
          recipients: [...recipients, newRecipient],
        }),
        this.handleInputChange,
      );
  };

  removeRecipient = (oldRecipient) => {
    this.setState(
      ({ recipients }) => ({
        recipients: recipients.filter(
          (recipient) => recipient !== oldRecipient,
        ),
      }),
      this.handleInputChange,
    );
  };

  renderSchedule = () => {
    const { classes } = this.props;

    const {
      frequency,
      scheduleDay,
      scheduleHour,
      scheduleStartOfPeriod,
    } = this.state;

    const scheduleStartOfPeriodValue =
      scheduleStartOfPeriod === undefined ? true : scheduleStartOfPeriod;

    const frequencyValue = frequency || placeholderValue;

    let scheduleHourValue = scheduleHour;
    if (scheduleHourValue > 12)
      scheduleHourValue = parseInt((scheduleHour || 9) % 12);
    if (scheduleHourValue === undefined) {
      scheduleHourValue = 9;
    }

    return (
      <>
        <InputLabel>
          Schedule email digest
          <InputLabelTooltip title="Select how often the email digest should be sent." />
        </InputLabel>

        <div className={classes.scheduleField}>
          <Select
            className={classes.frequency}
            value={frequencyValue}
            onChange={(event) => {
              this.handleFieldChange('frequency', event.target.value);
            }}>
            <MenuItem value="hourly">Hourly</MenuItem>
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
          </Select>
          {frequencyValue === 'monthly' && (
            <>
              on the
              <Select
                className={classes.scheduleDayOrder}
                value={scheduleStartOfPeriodValue}
                onChange={(event) => {
                  this.handleFieldChange(
                    'scheduleStartOfPeriod',
                    event.target.value,
                  );
                }}>
                <MenuItem value>first</MenuItem>
                <MenuItem value={false}>last</MenuItem>
              </Select>{' '}
              <Select
                className={classes.scheduleDay}
                value={scheduleDay || 0}
                onChange={(event) => {
                  this.handleFieldChange('scheduleDay', event.target.value);
                }}>
                <MenuItem value={0}>Sunday</MenuItem>
                <MenuItem value={1}>Monday</MenuItem>
                <MenuItem value={2}>Tuesday</MenuItem>
                <MenuItem value={3}>Wednesday</MenuItem>
                <MenuItem value={4}>Thursday</MenuItem>
                <MenuItem value={5}>Friday</MenuItem>
                <MenuItem value={6}>Saturday</MenuItem>
              </Select>
              of the month{' '}
            </>
          )}
          {frequencyValue === 'weekly' && (
            <>
              on
              <Select
                className={classes.scheduleDay}
                value={scheduleDay || 0}
                onChange={(event) => {
                  this.handleFieldChange('scheduleDay', event.target.value);
                }}>
                <MenuItem value={0}>Sunday</MenuItem>
                <MenuItem value={1}>Monday</MenuItem>
                <MenuItem value={2}>Tuesday</MenuItem>
                <MenuItem value={3}>Wednesday</MenuItem>
                <MenuItem value={4}>Thursday</MenuItem>
                <MenuItem value={5}>Friday</MenuItem>
                <MenuItem value={6}>Saturday</MenuItem>
              </Select>
            </>
          )}

          {frequencyValue !== 'hourly' && (
            <>
              at
              <Select
                className={classes.scheduleHour}
                classes={{ root: 'hourSelect' }}
                value={scheduleHourValue === 0 ? 12 : scheduleHourValue}
                onChange={this.handleHourChange}>
                {hourMenuItems()}
              </Select>
              <Select
                className={classes.scheduleAmPm}
                classes={{ root: 'amPmSelect' }}
                value={scheduleHour >= 12 ? 'pm' : 'am'}
                onChange={this.handleAmPmChange}>
                <MenuItem value="am">am</MenuItem>
                <MenuItem value="pm">pm</MenuItem>
              </Select>
            </>
          )}
        </div>
      </>
    );
  };

  renderCustomize = () => {
    const { attributes, classes, typename } = this.props;

    return (
      <>
        <h2 className={classes.subheading}>Customize your CSV</h2>

        <p className={classes.columnsHelperText}>
          Select which attributes you want to include as columns in your CSV
        </p>

        <MultiPicklist
          hubspotComingSoon
          allColumns={attributes}
          onChange={(value) => {
            this.handleFieldChange('columns', value);
          }}
          type={legacySegmentType(typename)}
          value={this.state.columns}
        />
      </>
    );
  };

  renderTestButton = () => {
    const { classes, segmentId, segmentType } = this.props;
    const {
      columns,
      duplicateSuppressionTimeframe,
      frequency,
      testRecipient,
      subject,
    } = this.state;

    return (
      <>
        <h2 className={classes.subheading}>Test this destination</h2>
        <span className={classes.triggerSubtext}>
          Run a test by manually triggering this destination
        </span>
        <div className={classes.contentBox}>
          <DeliverTestButton
            config={{
              columns,
              duplicateSuppressionTimeframe,
              frequency,
              recipients: [testRecipient],
              subject,
            }}
            label="email"
            destinationType="email"
            segmentId={segmentId}
            segmentType={segmentType}>
            <TextField
              label="Test email recipient"
              FormControlProps={{
                classes: {
                  root: classes.testRecipientTextField,
                },
              }}
              onChange={(event) =>
                this.setState({ testRecipient: event.target.value })
              }
              value={testRecipient}
              variant="outlined"
            />
          </DeliverTestButton>
        </div>
      </>
    );
  };

  renderEmailOptions = () => {
    const { classes, errors, typename } = this.props;

    const { recipients, subject } = this.state;

    return (
      <>
        <ChipInput
          error={hasError(errors, 'recipients')}
          fullWidth
          helperText={
            hasError(errors, 'recipients') &&
            'Please enter a valid email address.'
          }
          InputProps={{
            style: {
              minWidth: 180,
            },
            placeholder:
              recipients.length == 0
                ? 'alex@clearbit.com'
                : 'Add more recipients',
          }}
          classes={{
            root: classes.chipInput,
            chipContainer: classes.chipContainer,
          }}
          label="Recipients"
          onAdd={this.addRecipient}
          onBlur={(e) => this.addRecipient(e.target.value)}
          onDelete={this.removeRecipient}
          placeholder="Type emails here..."
          required
          value={recipients}
        />

        <TextField
          className={classes.field}
          error={hasError(errors, 'subject')}
          defaultValue={subject}
          fullWidth
          InputProps={{
            placeholder: `New ${readableSegmentType(typename)} matched`,
          }}
          label="Email subject"
          onChange={(event) => {
            this.handleFieldChange('subject', event.target.value);
          }}
          required
          variant="standard"
        />
      </>
    );
  };

  render() {
    const { classes, errors, typename } = this.props;
    const { duplicateSuppressionTimeframe, triggerType } = this.state;

    return (
      <>
        <h2 className={classes.subheading}>Trigger</h2>
        <span className={classes.triggerSubtext}>
          Select the event that triggers this Destination to run.{' '}
          <a
            href="https://help.clearbit.com/hc/en-us/articles/360023453694"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}>
            Learn more
          </a>
        </span>

        <TriggerType
          errors={errors}
          handleChange={this.handleFieldChange}
          triggerType={triggerType}
          triggerTypes={defaultTriggerTypes(typename)}
        />

        <h2 className={classes.subheading}>Configure email options</h2>

        <div className={classes.contentBox}>
          {this.renderEmailOptions()}

          <hr className={classes.break} />

          <SuppressionForm
            typename={readableSingularSegmentType(typename)}
            exclusion_timeframe={duplicateSuppressionTimeframe}
            onChange={({ exclusion_timeframe }) => {
              this.handleFieldChange(
                'duplicateSuppressionTimeframe',
                exclusion_timeframe,
              );
            }}
          />

          <hr className={classes.break} />

          {this.renderSchedule()}
        </div>

        {this.renderCustomize()}

        {this.renderTestButton()}
      </>
    );
  }
}

Email.propTypes = {
  attributes: PropTypes.array.isRequired, //TODO: arrayOf
  classes: PropTypes.object.isRequired,
  destination: PropTypes.object,
  errors: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  segmentId: PropTypes.string.isRequired,
  segmentType: PropTypes.string.isRequired,
  typename: PropTypes.string.isRequired,
};

export default withStyles(
  (theme) => ({
    ...sharedStyles(theme),
    ...styles(theme),
  }),
  { name: 'SegmentDestinationNewEmail' },
)(Email);
